import request from "./../utils/request";

export function getCategories() {
    return request.get("/catalog");
}

export function getContents(parentId) {
    return request.get(`/catalog/${parentId}`);
}

export function rateContents(payload) {
    let { id, rate } = payload;
    return request.put(`/catalog/${id}/rate`, { rate: rate });
}

export function increaseViewCatalog(id) {
    return request.patch(`/catalog/${id}`);
}
export function searchCatalog(query, lang) {
    return request.get(`/catalog/search?q=${query}&lang=${lang}`);
}



// WEBPACK FOOTER //
// ./src/api/catalog.js